import { CamelCaseKeys } from '@utils/typescript';
import { tEnum } from '@components/i18n';
import { ClaimStatuses } from '@models/InsuranceClaim';
import { PaymentInfo } from '@models/PaymentInfo';

export enum PersonalAccidentClaimTypes {
  Death = 'Death',
  PermanentAndTotalDisablement = 'Permanent and total disablement',
  PermanentAndPartialDisablement = 'Permanent and partial disablement',
  MedicalExpense = 'Medical expense',
  CashAllowance = 'Cash allowance',
  InternationalEmergencyMedicalAssistance = 'International emergency medical assistance',
  Others = 'Others',
}

export type PersonalAccidentClaim = CamelCaseKeys<{
  id: number;
  status: ClaimStatuses;
  accident_happened_at: string;
  claim_type?: PersonalAccidentClaimTypes;
  completed_claim_forms: string[];
  supporting_documents: string[];
  additional_documents: string[];
  invoice: string;
  total_claimed_amount: number;
  approved_amount: number;
  note: string;
  claim_number: string;
  payment_info: PaymentInfo;
}>;

export const getPersonalAccidentClaimType = (type: PersonalAccidentClaimTypes) =>
  tEnum('personalAccidentClaimTypes', type);
